import _ from 'underscore';

import {assert} from 'Asserts';
import {
  FULFILLMENT_STATUS_ICONS,
  FulfillmentStatus,
  RequestFulfillment,
} from 'requests/fulfillments/FulfillmentConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

/**
 * Aggregate fulfillment statuses for a request, sample group, etc.
 * @param {*} fulfillments
 */
export function aggregateFulfillmentStatuses(fulfillments: Array<RequestFulfillment>): FulfillmentStatus {
  if (fulfillments.length === 0) {
    return FulfillmentStatus.PENDING;
  }
  // eslint-disable-next-line no-restricted-syntax
  const mostRecentFulfillment = _.last(_.sortBy(fulfillments, 'createdAt'))!;
  if (mostRecentFulfillment.status === FulfillmentStatus.FAILED) {
    // Display failed as "Pending" since this is the result of "Mark for redo"
    return FulfillmentStatus.PENDING;
  }
  return mostRecentFulfillment.status;
}

export function getIconAndClassNameForStatus(status: FulfillmentStatus): {
  className: string;
  icon: BenchlingIconName;
} {
  const iconInfo = FULFILLMENT_STATUS_ICONS[status];
  assert(Boolean(iconInfo), `No icon found for fulfillment status "${status}"`);
  return iconInfo;
}
